import { transform } from "ol/proj";
import { store } from "../../../../../stateManagement/store";
import { setMapTooltipEventYear, setMapTooltipExecutorOrgName, setMapTooltipInfoCopied, setMapTooltipKm, setMapTooltipLength, setMapTooltipNormativityMarker, setMapTooltipPathName, setMapTooltipRoadBedType, setMapTooltipRoadAccidentInfo, setMapTooltipRoadAccidentSegmentInfo, setMapTooltipRoadCategory, setMapTooltipRoadName, setMapTooltipSegmentEnding, setMapTooltipSegmentStart, setMapTooltipIsVisible, setMapTooltipWorkState, setMapTooltipEventTypeString, setMapTooltipEventTypeId, setMapTooltipIsLoading } from "../../../../../stateManagement/reducers/MapTooltipSlice";
import { findMaxEventYearFeature } from "../../helpers";
import { formatDate, transformObjectWithEnums } from "../../../../../features/dataFormatFunctions/dataFormatter";
import { featurePropsForMapTooltip, getFeatureURLParamsObject } from "../getObjectsOnMapPoint/getObjectsOnMapPoint";
import { getItemWebStorage } from "../../../../../features/webStorageSaver";
import { getBasicObjectTypeLayer } from "../../layers";
import { fetchCoordsToPosition } from "../../../../../api/mapApi";
import type TileLayer from "ol/layer/Tile";
import type { TileWMS } from "ol/source";
import { shortMeasureTypesNames } from "../../../../diagnostics/diagnosticsPathNormativitiesSection";
import { roadBedFiltersOptions } from "../../../mapAddons/mapOverlayWidget/roadBedLayerSegmentsOverlay";
import { roadCategoryFiltersOptions } from "../../../mapAddons/mapOverlayWidget/roadCategorySegmentsOverlay";
import { showToastMessage } from "../../../../../stateManagement/reducers";

let cursorTimer: any;
const currentConfig = getItemWebStorage('currentConfig')
const { wmsServer, wmsVersion, workspace } = currentConfig ?? {}

async function getSegmentNormativityBounds(segmentNormativityId: any, pathNormativityId: any, measureType: any, chosenMapMultipleMeasureTypes: any) {
    let apiUrl = currentConfig?.irosRestApiUrl
    const token = store.getState().auth.tokens.app
    let url
    if (measureType) {
        url = `${apiUrl}/diagnostics/segmentNormativityBounds?SegmentNormativityId=${segmentNormativityId}&PathNormativityId=${pathNormativityId}&${measureType}=true`;
    } else {
        let filterMeasures = ''
        Object.keys(chosenMapMultipleMeasureTypes).map(measure => {
            if (chosenMapMultipleMeasureTypes[measure]) {
                filterMeasures += `&${measure}=true`
            }
        })
        url = `${apiUrl}/diagnostics/segmentNormativityBounds?SegmentNormativityId=${segmentNormativityId}&PathNormativityId=${pathNormativityId}` + filterMeasures;
    }
    try {
        const response: any = await fetch(url, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (response.ok) {
            const data = await response.json();
            const { StartKm, EndKm } = data ?? {}
            if (StartKm && EndKm) {
                store.dispatch(setMapTooltipSegmentStart(data?.StartKm.toFixed(2)?.replace('.', ',')))
                store.dispatch(setMapTooltipSegmentEnding(data?.EndKm.toFixed(2)?.replace('.', ',')))
            }
        }
    } catch (error) {

    }
}

export async function showMapTooltip(event: any, type: any, layer: TileLayer<TileWMS>, map: any, measureType?: any) {
    const { pathNormativitiesMapMultipleMeasureTypes: mapMultipleMeasureTypes, pathNormativitiesMapNormativityFlag: mapNormativityFlag, pathNormativitiesMapYearFilter: chosenYearFromPathNormativities } = store.getState().diagnosticsPathNormativities
    let layersNames = layer?.getSource()?.getParams()?.LAYERS
    let cqlFilter = layer?.getSource()?.getParams()?.CQL_FILTER
    let styles = layer?.getSource()?.getParams()?.STYLES
    clearTimeout(cursorTimer); // Очищаем предыдущий таймер при каждом вызове функции
    cursorTimer = setTimeout(async () => { // Устанавливаем новый таймер
        store.dispatch(setMapTooltipIsLoading(true))
        let kmOffset
        if (type !== 'RoadAccidents') {
            try {
                const eventCoords = transform(event.coordinate, 'EPSG:3857', 'EPSG:4326')
                const actualRoadQuery = await fetchCoordsToPosition('0', '0', eventCoords[1], eventCoords[0])
                kmOffset = actualRoadQuery?.Offset
                store.dispatch(setMapTooltipKm(actualRoadQuery?.ProjectPosition?.replace('.', ',')))
                store.dispatch(setMapTooltipRoadName(actualRoadQuery?.RoadName))
                store.dispatch(setMapTooltipPathName(actualRoadQuery?.PathName))
            } catch {
                store.dispatch(showToastMessage({ messageText: 'В заданной позиции дорога не найдена', messageType: "error", windowType: "map" }))
            }
        }
        let layerURL: any
        let propsType = type
        if (type === 'RoadAccidents' || Math.abs(parseFloat(kmOffset)) < 200) {
            if (type === 'pathNormativities') {
                layerURL = 'MADiagSegmentNormativity'
                if (measureType) {
                    propsType = 'pathNormativities' + measureType
                }
                if (!measureType) {
                    propsType = 'pathNormativitiesGroup'
                    const filtersArray = Object.entries(mapMultipleMeasureTypes)
                        .filter(([key, value]) => value === true)
                        .map(([key, value]) => `${key}=${mapNormativityFlag ? 1 : 0}`)
                        ?.join(' and ');
                    cqlFilter = `DiagnosticYear in (${chosenYearFromPathNormativities}) and ${filtersArray}`;
                    styles = mapNormativityFlag ? 'MADiagSegmentNormativityAllGreens' : 'MADiagSegmentNormativityAllReds'
                }
            } else if (type === 'RoadAccidents') {
                layerURL = 'MARoadAccidentForFilters'
            }
            layersNames = layersNames?.replace('MC', 'MA')
            const view = map.getView();
            const viewResolution = view.getResolution();
            const viewProjection = view.getProjection();
            if (layer) {
                let url = layer.getSource()?.getFeatureInfoUrl(
                    event.coordinate,
                    viewResolution,
                    viewProjection,
                    getFeatureURLParamsObject({
                        VERSION: wmsVersion,
                        LAYERS: layersNames,
                        CQL_FILTER: cqlFilter,
                        styles,
                        propertyName: featurePropsForMapTooltip[propsType] ?? null,
                        buffer: null
                    })
                )
                const urlParts = url?.split('?');
                if (urlParts?.length === 2) {
                    if (url) {
                        fetch(url)
                            .then((response) => response.json())
                            .then((data) => {
                                let newTooltipData: any
                                if (type === 'pathNormativities') {
                                    newTooltipData = data.features[0]?.properties
                                    getSegmentNormativityBounds(newTooltipData.InfoObjectID, newTooltipData.PathNormativityId, measureType, mapMultipleMeasureTypes)
                                    if (measureType) {
                                        store.dispatch(setMapTooltipNormativityMarker(parseFloat(newTooltipData[measureType])))
                                    }
                                }
                                if (type === 'highwayNetworkSegments') {
                                    newTooltipData = data.features[0]?.properties
                                    store.dispatch(setMapTooltipSegmentStart(newTooltipData?.Position.toFixed(2)?.replace('.', ',')))
                                    store.dispatch(setMapTooltipSegmentEnding(newTooltipData?.Ending.toFixed(2)?.replace('.', ',')))
                                }
                                if (type === 'RoadAccidents') {
                                    newTooltipData = data.features[0]?.properties
                                    let roadAccidentDateAndTime = formatDate(newTooltipData?.DateAndTime)
                                    let roadAccidentDate = roadAccidentDateAndTime.split(' ')[0]
                                    let roadAccidentTime = roadAccidentDateAndTime.split(' ')[1]
                                    let roadAccidentType = newTooltipData?.AccidentTypeString?.split(' ')
                                    let roadAccidentTypeId = newTooltipData?.AccidentTypeId
                                    roadAccidentType.splice(0, 2)
                                    roadAccidentType = roadAccidentType.join(' ')
                                    let roadAccidentInfo = {
                                        roadAccidentDate,
                                        roadAccidentTime,
                                        roadAccidentType,
                                        roadAccidentTypeId,
                                        roadAccidentDeathRoll: newTooltipData?.DeathRoll,
                                        roadAccidentWoundedCount: newTooltipData?.WoundedCount
                                    }
                                    store.dispatch(setMapTooltipRoadAccidentInfo(roadAccidentInfo))
                                    store.dispatch(setMapTooltipKm(newTooltipData?.Position.toFixed(3).replace('.', ',')))
                                    store.dispatch(setMapTooltipRoadName(newTooltipData?.RoadName))
                                    store.dispatch(setMapTooltipPathName(newTooltipData?.PathName))
                                }
                                if (type === 'RoadAccidentSegments') {
                                    newTooltipData = transformObjectWithEnums(data.features[0]?.properties)
                                    store.dispatch(setMapTooltipSegmentStart(newTooltipData?.Position.toFixed(2)?.replace('.', ',')))
                                    store.dispatch(setMapTooltipSegmentEnding(newTooltipData?.Ending.toFixed(2)?.replace('.', ',')))
                                    let roadAccidentSegmentStatus = newTooltipData?.Status
                                    let roadAccidentSegmentTotalAccidentNumber = newTooltipData?.TotalAccidentNumber
                                    let roadAccidentSegmentInfo = {
                                        roadAccidentSegmentStatus,
                                        roadAccidentSegmentTotalAccidentNumber
                                    }
                                    store.dispatch(setMapTooltipRoadAccidentSegmentInfo(roadAccidentSegmentInfo))
                                }
                                if (type === 'RoadDiagnosticsSegments' || type === 'RoadDiagnosticsSegmentsPassport') {
                                    newTooltipData = findMaxEventYearFeature(data.features)?.properties
                                    store.dispatch(setMapTooltipExecutorOrgName(newTooltipData?.ExecutorOrgName))
                                    store.dispatch(setMapTooltipLength(newTooltipData?.LengthAlongRoad.toFixed(2)?.replace('.', ',')))
                                    store.dispatch(setMapTooltipEventYear(newTooltipData?.EventYear))
                                    store.dispatch(setMapTooltipSegmentStart(newTooltipData?.Position.toFixed(2)?.replace('.', ',')))
                                    store.dispatch(setMapTooltipSegmentEnding(newTooltipData?.Ending.toFixed(2)?.replace('.', ',')))
                                }
                                if (type === 'roadBedLayerSegments') {
                                    newTooltipData = data.features[0]?.properties
                                    store.dispatch(setMapTooltipSegmentStart(newTooltipData?.Position.toFixed(2)?.replace('.', ',')))
                                    store.dispatch(setMapTooltipSegmentEnding(newTooltipData?.Ending.toFixed(2)?.replace('.', ',')))
                                    store.dispatch(setMapTooltipLength(newTooltipData?.LengthAlongRoad.toFixed(2)?.replace('.', ',')))
                                    let roadBedType
                                    Object.keys(roadBedFiltersOptions).map((key) => {
                                        if (roadBedFiltersOptions[key].roadbedTypeId === newTooltipData?.RoadbedTypeID) {
                                            roadBedType = roadBedFiltersOptions[key]?.name
                                        }
                                    })
                                    store.dispatch(setMapTooltipRoadBedType({ roadBedType, roadBedTypeId: newTooltipData?.RoadbedTypeID }))
                                }
                                if (type === 'roadCategorySegments') {
                                    newTooltipData = data.features[0]?.properties
                                    store.dispatch(setMapTooltipSegmentStart(newTooltipData?.Position.toFixed(2)?.replace('.', ',')))
                                    store.dispatch(setMapTooltipSegmentEnding(newTooltipData?.Ending.toFixed(2)?.replace('.', ',')))
                                    store.dispatch(setMapTooltipLength(newTooltipData?.LengthAlongRoad.toFixed(2)?.replace('.', ',')))
                                    let category
                                    Object.keys(roadCategoryFiltersOptions).map((key) => {
                                        if (roadCategoryFiltersOptions[key].categoryId === newTooltipData?.RelativeCategoryId) {
                                            category = roadCategoryFiltersOptions[key]?.name
                                        }
                                    })
                                    store.dispatch(setMapTooltipRoadCategory({ roadCategory: category, roadCategoryId: newTooltipData?.RelativeCategoryId }))
                                }
                                if (type === 'RoadWorkSegmentsPODD') {
                                    newTooltipData = data.features[0]?.properties
                                    store.dispatch(setMapTooltipSegmentStart(newTooltipData?.Position.toFixed(2)?.replace('.', ',')))
                                    store.dispatch(setMapTooltipSegmentEnding(newTooltipData?.Ending.toFixed(2)?.replace('.', ',')))
                                    store.dispatch(setMapTooltipEventYear(newTooltipData?.EventYear))
                                    store.dispatch(setMapTooltipLength(newTooltipData?.LengthAlongRoad.toFixed(2)?.replace('.', ',')))
                                    store.dispatch(setMapTooltipExecutorOrgName(newTooltipData?.ExecutorOrgName))
                                }
                                if (type === 'RoadWorks') {
                                    newTooltipData = findMaxEventYearFeature(data.features)?.properties
                                    const workState = data.features.at(-1)?.id.includes('Planned') ? 'Запланировано' : 'Проведено';
                                    store.dispatch(setMapTooltipWorkState(workState))
                                    store.dispatch(setMapTooltipEventTypeId(newTooltipData?.EventStandartTypeId))
                                    store.dispatch(setMapTooltipEventTypeString(newTooltipData?.EventTypeString))
                                    store.dispatch(setMapTooltipSegmentStart(newTooltipData?.Position.toFixed(2)?.replace('.', ',')))
                                    store.dispatch(setMapTooltipSegmentEnding(newTooltipData?.Ending.toFixed(2)?.replace('.', ',')))
                                    store.dispatch(setMapTooltipEventYear(newTooltipData?.EventYear))
                                    store.dispatch(setMapTooltipLength(newTooltipData?.LengthAlongRoad.toFixed(2)?.replace('.', ',')))
                                    store.dispatch(setMapTooltipExecutorOrgName(newTooltipData?.ExecutorOrgName))
                                }
                                if (type === 'RoadWorksWithNormativities') {
                                    const filteredFeatures = data.features.filter(feature => feature.id.includes('Work'))
                                    if (filteredFeatures.length > 0) {
                                        newTooltipData = findMaxEventYearFeature(filteredFeatures)?.properties
                                        const workState = filteredFeatures.at(-1)?.id.includes('Planned') ? 'Запланировано' : 'Проведено';
                                        store.dispatch(setMapTooltipWorkState(workState))
                                        store.dispatch(setMapTooltipEventTypeId(newTooltipData?.EventStandartTypeId))
                                        store.dispatch(setMapTooltipEventTypeString(newTooltipData?.EventTypeString))
                                        store.dispatch(setMapTooltipSegmentStart(newTooltipData?.Position.toFixed(2)?.replace('.', ',')))
                                        store.dispatch(setMapTooltipSegmentEnding(newTooltipData?.Ending.toFixed(2)?.replace('.', ',')))
                                        store.dispatch(setMapTooltipEventYear(newTooltipData?.EventYear))
                                        store.dispatch(setMapTooltipLength(newTooltipData?.LengthAlongRoad.toFixed(2)?.replace('.', ',')))
                                        store.dispatch(setMapTooltipExecutorOrgName(newTooltipData?.ExecutorOrgName))
                                    }
                                }
                                store.dispatch(setMapTooltipInfoCopied(false))
                                store.dispatch(setMapTooltipIsVisible(newTooltipData))
                                store.dispatch(setMapTooltipIsLoading(false))
                            })
                            .catch((error) => {
                                store.dispatch(setMapTooltipIsVisible(false))
                                store.dispatch(setMapTooltipInfoCopied(false))
                            });
                    }
                }
            }
        } else {
            store.dispatch(setMapTooltipIsVisible(false))
        }
    }, 150);
}

function checkValue(value: any) {
    let checkedValue = value ? value : "—"
    return checkedValue
}

// функция копирования данных из подсказки
export function copyInfoFromTooltip(measureType?: any, normativityFlag?: any, chosenMapMultipleMeasureTypes?: any) {
    const mapHintVisibility = store.getState().mapTooltip.mapTooltipIsVisible
    const { tooltipRoadName: roadName,
        tooltipPathName: pathName,
        tooltipKm: km,
        tooltipNormativityMarker: normativityMarker,
        tooltipSegmentStart: segmentStart,
        tooltipSegmentEnding: segmentEnding,
        roadBedType,
        roadCategory: roadCategory,
        roadAccidentSegmentStatus,
        roadAccidentSegmentTotalAccidentNumber
    } = store.getState().mapTooltip

    let checkedRoadName = checkValue(roadName)
    let checkedPathName = checkValue(pathName)
    let checkedSegmentStart = checkValue(segmentStart)
    let checkedSegmentEnding = checkValue(segmentEnding)
    let checkedKm = checkValue(km)

    // Проверка на тип
    let tooltipType: any
    const fourthSplit = window.location.pathname.split('/')[4]
    tooltipType = fourthSplit
    if (mapHintVisibility) {
        let copyInfoText: string = ''
        if (tooltipType === "PathNormativities") {
            if (measureType) {
                copyInfoText = `Дорога: ${checkedRoadName}; Направление: ${checkedPathName}; Начало участка: ${checkedSegmentStart}; Конец участка: ${checkedSegmentEnding}; Км: ${checkedKm}` + ';' + ' ' +
                    `Тип измерения: ${checkValue(shortMeasureTypesNames[measureType])}; Состояние: ${normativityMarker ? 'В нормативе' : 'Не в нормативе'}`
            }
            else {
                let activeMeasureTypes: any[] = []
                Object.keys(chosenMapMultipleMeasureTypes).map((measureType: any): void => {
                    if (chosenMapMultipleMeasureTypes[measureType]) {
                        activeMeasureTypes.push(shortMeasureTypesNames[measureType]);
                    }
                });
                copyInfoText = `Дорога: ${checkedRoadName}; Направление: ${checkedPathName}; Начало участка: ${checkedSegmentStart}; Конец участка: ${checkedSegmentEnding}; Км: ${checkedKm}` + ';' + ' ' +
                    `Типы измерений: ${activeMeasureTypes ? activeMeasureTypes.join(', ') : "-"}; Состояние: ${normativityFlag ? 'В нормативе' : 'Не в нормативе'}`
            }
        }
        if (tooltipType === "HighwayNetworkSegments") {
            copyInfoText = `Дорога: ${checkedRoadName}; Направление: ${checkedPathName}; Начало участка: ${checkedSegmentStart}; Конец участка: ${checkedSegmentEnding}; Км: ${checkedKm}`
        }
        if (tooltipType === "RoadBedLayerSegments") {
            copyInfoText = `Дорога: ${checkedRoadName}; Направление: ${checkedPathName}; Начало участка: ${checkedSegmentStart}; Конец участка: ${checkedSegmentEnding}; Км: ${checkedKm}; Тип дорожной одежды: ${checkValue(roadBedType)}`
        }
        if (tooltipType === "RoadCategorySegments") {
            copyInfoText = `Дорога: ${checkedRoadName}; Направление: ${checkedPathName}; Начало участка: ${checkedSegmentStart}; Конец участка: ${checkedSegmentEnding}; Км: ${checkedKm}; Категория дороги: ${checkValue(roadCategory)}`
        }
        if (tooltipType === "RoadAccidentSegments") {
            copyInfoText = `Дорога: ${checkedRoadName}; Направление: ${checkedPathName}; Начало участка: ${checkedSegmentStart}; Конец участка: ${checkedSegmentEnding}; Км: ${checkedKm}; Статус: ${checkValue(roadAccidentSegmentStatus)}; Количество ДТП: ${checkValue(roadAccidentSegmentTotalAccidentNumber)}`
        }
        navigator.clipboard.writeText(copyInfoText)
            .then()
            .catch(error => {
                console.error('Ошибка копирования', error);
            });
    }
    store.dispatch(setMapTooltipInfoCopied(true))
}